import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import { OnlyFansAllCounters } from './useMetricsDailyStats';
import useAxios from './useAxios';

const useSubscriberUsersCounters = (subscriberId: string | undefined) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    const fetchData = async (): Promise<OnlyFansAllCounters | null> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !subscriberId) {
            return null;
        }

        const query = `${settingsContext.routes.onlyFans.base}${subscriberId}/users/counters`;

        return axios
            .get(query)
            .then((response) => response.data as OnlyFansAllCounters)
            .catch((error) => {
                handleHttpError(error, dialog);

                return null;
            });
    };

    return useQuery(['subscriberUsersCounters', subscriberId], fetchData, {
        refetchOnWindowFocus: false,
        staleTime: 60 * 1000,
        enabled: !!(userContext.jwtToken && settingsContext.apiKey && subscriberId),
    });
};

export default useSubscriberUsersCounters;
